import React from 'react';
import { DataTable } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { ProgressBar } from '../components/ProgressBar';
import { auditJobs } from '../data/mockData';
import { Play, Pause, Eye, Download } from 'lucide-react';
import { toast } from 'sonner';

export default function AuditJobs() {
  const handleAction = (action, job) => {
    toast.success(`${action} action triggered for ${job.id}`);
  };

  const handleExportCSV = () => {
    const headers = ['Job ID', 'Target URL', 'Status', 'Severity', 'Progress', 'Start Date', 'End Date'];
    const rows = auditJobs.map(job => [
      job.id,
      job.targetUrl,
      job.status,
      job.severity,
      `${job.progress}%`,
      job.startDate,
      job.endDate
    ]);
    
    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.join(','))
    ].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'audit_jobs_export.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    toast.success('Audit jobs exported to CSV');
  };

  const columns = [
    { key: 'id', label: 'Job ID' },
    { key: 'targetUrl', label: 'Target URL' },
    { 
      key: 'status', 
      label: 'Status',
      render: (row) => <StatusBadge status={row.status} />
    },
    { 
      key: 'severity', 
      label: 'Severity',
      render: (row) => <StatusBadge severity={row.severity} />
    },
    { 
      key: 'progress', 
      label: 'Progress',
      render: (row) => <ProgressBar progress={row.progress} />
    },
    { key: 'startDate', label: 'Start' },
    { key: 'endDate', label: 'End' },
    {
      key: 'actions',
      label: 'Actions',
      render: (row) => (
        <div className="action-buttons">
          <button 
            className="action-btn btn-primary"
            onClick={() => handleAction('View', row)}
            data-testid={`view-audit-${row.id}`}
          >
            <Eye size={16} />
          </button>
          {row.status === 'running' ? (
            <button 
              className="action-btn btn-warning"
              onClick={() => handleAction('Pause', row)}
              data-testid={`pause-audit-${row.id}`}
            >
              <Pause size={16} />
            </button>
          ) : row.status === 'pending' && (
            <button 
              className="action-btn btn-success"
              onClick={() => handleAction('Start', row)}
              data-testid={`start-audit-${row.id}`}
            >
              <Play size={16} />
            </button>
          )}
        </div>
      )
    }
  ];

  return (
    <div className="page-container" data-testid="audit-jobs-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Audit Jobs</h1>
          <p className="page-subtitle">Manage and monitor security audit jobs</p>
        </div>
        <button 
          className="btn-success"
          onClick={handleExportCSV}
          data-testid="export-csv-button"
        >
          <Download size={18} />
          <span>Export CSV</span>
        </button>
      </div>

      <DataTable 
        columns={columns} 
        data={auditJobs} 
        searchable={true}
        emptyMessage="No audit jobs found"
      />
    </div>
  );
}
